import * as types from "./types";

export const setUpdateFlag = flag => {
  return {
    type: types.SET_UPDATE_FLAG,
    payload: flag,
  };
};

export const setDemographics = demographics => {
  return {
    type: types.SET_DEMOGRAPHICS,
    payload: demographics,
  };
};

export const triggerDeepUpdate = () => {
  return {
    type: types.TRIGGER_DEEP_UPDATE,
  };
};

export const deepUpdateComplete = () => {
  return {
    type: types.DEEP_UPDATE_COMPLETE,
  };
};

export const setDeviceName = device => {
  return {
    type: types.SET_DEVICE_NAME,
    payload: device,
  };
};
